(function () {
  const INTERACTION_EVENTS = [
    'mousedown',
    'mousemove',
    'keydown',
    'scroll',
    'touchstart',
    'keypress',
    'touchmove',
  ];

  const STORAGE_KEY = 'third-party-scripts-loaded';
  const SCRIPT_TIMEOUT = 2000;
  const IDLE_FALLBACK = 8000;
  const INTERACTION_DELAY = 300;

  let started = false;

  function start(delay) {
    INTERACTION_EVENTS.forEach(function (eventName) {
      window.removeEventListener(eventName, onUserActivity);
    });

    if (started) return;
    started = true;

    if (document.readyState !== 'complete') {
      window.addEventListener('load', loadScripts, { once: true });
      return;
    }

    if (delay) {
      setTimeout(loadScripts, delay);
      return;
    }

    loadScripts();
  }

  function onUserActivity() {
    start(INTERACTION_DELAY);
  }

  function loadScripts() {
    const lazyScripts = document.querySelectorAll('script[data-lazy-src]');
    const pending = [];

    lazyScripts.forEach(function (script) {
      pending.push(
        new Promise(function (resolve) {
          const timeoutId = setTimeout(resolve, SCRIPT_TIMEOUT);

          function done() {
            clearTimeout(timeoutId);
            resolve();
          }

          script.addEventListener('load', done, { once: true });
          script.addEventListener('error', done, { once: true });
          script.src = script.dataset.lazySrc;
        })
      );
    });

    window.dispatchEvent(new CustomEvent('load-head-scripts'));

    Promise.all(pending).then(function () {
      try {
        localStorage.setItem(STORAGE_KEY, 'true');
      } catch (error) {
        // storage can be unavailable in private mode
      }

      window.dispatchEvent(new CustomEvent(STORAGE_KEY));
      document.documentElement.classList.add(STORAGE_KEY);
    });
  }

  INTERACTION_EVENTS.forEach(function (eventName) {
    window.addEventListener(eventName, onUserActivity, { passive: true, once: true });
  });

  window.addEventListener('load', function () {
    let alreadyLoaded = false;

    try {
      alreadyLoaded = localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (error) {
      alreadyLoaded = false;
    }

    if (alreadyLoaded) {
      start(0);
      return;
    }

    setTimeout(function () {
      start(0);
    }, IDLE_FALLBACK);
  });
})();
